import React, { ReactNode } from 'react';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import { JobPostConfigStepId } from '../interfaces';
import { StepHeader } from './StepHeader';
import { StepSummary } from './StepSummary';

interface StepAccordionItemProps {
  stepId: JobPostConfigStepId;
  stepNumber: number;
  title: string;
  isActive: boolean;
  isCompleted: boolean;
  summaryText: string;
  metadataBadges?: string[];
  onSelect: () => void;
  children: ReactNode;
}

export const StepAccordionItem = ({
  stepId,
  stepNumber,
  title,
  isActive,
  isCompleted,
  summaryText,
  metadataBadges,
  onSelect,
  children,
}: StepAccordionItemProps) => {
  return (
    <Box
      sx={{
        borderRadius: '16px',
        bgcolor: 'background.paper',
        border: '1px solid',
        borderColor: isActive
          ? 'primary.main'
          : isCompleted
          ? 'rgba(16, 185, 129, 0.3)'
          : 'divider',
        boxShadow: isActive
          ? '0 10px 25px -5px rgba(99, 102, 241, 0.1), 0 8px 10px -6px rgba(99, 102, 241, 0.1)'
          : '0 1px 3px 0 rgba(0, 0, 0, 0.05)',
        overflow: 'hidden',
        transition: 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
        '&:hover': {
          borderColor: isActive
            ? 'primary.main'
            : 'primary.light',
          boxShadow: isActive
            ? '0 12px 28px -5px rgba(99, 102, 241, 0.15)'
            : '0 4px 12px -2px rgba(15, 23, 42, 0.08)',
        },
      }}
    >
      {/* Step Header Bar */}
      <Box
        onClick={isActive ? undefined : onSelect}
        sx={{
          p: { xs: 2, sm: 2.25 },
          bgcolor: isActive
            ? 'rgba(99, 102, 241, 0.04)'
            : 'background.paper',
          borderBottom: isActive ? '1px solid' : 'none',
          borderColor: 'rgba(99, 102, 241, 0.12)',
          cursor: isActive ? 'default' : 'pointer',
          transition: 'background-color 0.2s ease',
        }}
      >
        <StepHeader
          stepId={stepId}
          stepNumber={stepNumber}
          title={title}
          isActive={isActive}
          isCompleted={isCompleted}
          onSelectStep={onSelect}
        />

        {/* Collapsed Step Summary */}
        {!isActive && (
          <StepSummary
            summaryText={summaryText}
            metadataBadges={metadataBadges}
          />
        )}
      </Box>

      {/* Expanded Step Body */}
      <Collapse in={isActive} timeout={300} unmountOnExit={false}>
        <Box
          sx={{
            p: { xs: 1.5, sm: 2.5 },
            bgcolor: 'background.paper',
          }}
        >
          {children}
        </Box>
      </Collapse>
    </Box>
  );
};
